import Repository from './Repository'

export default {

    getTemplates() {
        return Repository.get('/author/site_templates')
    },
    getActiveTemplate() {
        return Repository.get('/author/site_template_active')
    },
    getSiteTemplates() {
        return Repository.get(`/site_templates`);
    },
    createTemplate(payload) {
        return Repository.post(`/author/site_template/create`, payload)
        // return Repository.post(`/build_site_template`, payload)
    },
    createDeepSkyClient() {
        console.log('repo');
        return Repository.post(`/build_site_template`, {
            'template': 'deep_sky',
            'name': 'Deep sky client'
        })
    },
    activateTemplate(payload) {
        return Repository.post(`/author/site_template/${payload}/activate`)
    },
    cloneTemplate(payload) {
        return Repository.post(`/author/site_template/${payload.id}/clone`, payload)
    },
    deleteTemplate(payload) {
        return Repository.delete(`/author/site_template/${payload}`)
    },
    saveTemplate(payload) {
        return Repository.post(`/author/site_template/${payload.id}`, payload)
    },

    exportTemplate(siteTemplateId, exportParams) {
        return Repository({
            url: `${window.api}author/site_template/${siteTemplateId}/export?${window.oauthInfo}`,
            method: 'POST',
            data: exportParams,
            responseType: 'blob', // important
        }).then((blob) => {
            if (blob.data.type === 'application/json') {
                return blob.data.text().then((textResponse) => {
                    const data = JSON.parse(textResponse)
                    console.log(data)
                    return Promise.reject(data.errors)
                })
            }

            const url = window.URL.createObjectURL(new Blob([blob.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${exportParams.siteTemplateName}.zip`);
            document.body.appendChild(link);
            link.click();
        });
    },

    takeScreenshot(siteTemplateId) {

        if (!siteTemplateId) {
            return;
        }

        const url = `author/site_template/${siteTemplateId}/screenshot`;
        const data = { baseURL: window.clientURL };

        const form = new FormData();
        form.append('baseURL', data.baseURL);
        form.append('_token', window.usertoken);

        if (navigator.sendBeacon) {
            navigator.sendBeacon(`${window.server}${url}`, form);
        } else {
            // For browsers that do not support beacon send sync request.
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${window.server}${url}`, false);
            xhr.setRequestHeader("Authorization", "Basic bWlzdHJpOnBpbG9mb3Jp");
            xhr.send(form);
        }

        // return Repository({
        //     'method': 'post',
        //     'url': `${window.server}${url}`,
        //     data
        // } ,{
        //     headers: {
        //         'Authorization': `Basic bWlzdHJpOnBpbG9mb3Jp`
        //     }
        // })
    },

    getSiteTemplateSourceSettings(payload) {
        return Repository({
            method: 'get',
            url: `/site_template_source/${payload}/settings`,
            baseURL: window.clientURL
        })
    }
}

